import { UserDiseaseModel } from './userDiseaseModel';
import { UserDiseaseHistoryModel } from './userDiseaseHistoryModel';

export class UserDiseaseWithHistoryModel {
    public userDisease: UserDiseaseModel;
    public userDiseaseHistory: UserDiseaseHistoryModel;
}